"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("react-science/ui");
const ChangeSumModalContents_1 = require("./ChangeSumModalContents");
function ChangeSumModal({ renderButton, ...otherProps }) {
    const [isOpenDialog, openDialog, closeDialog] = (0, ui_1.useOnOff)(false);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [renderButton(openDialog), (0, jsx_runtime_1.jsx)(ui_1.Modal, { isOpen: isOpenDialog, onRequestClose: closeDialog, width: 500, height: 400, children: (0, jsx_runtime_1.jsx)(ChangeSumModalContents_1.ChangeSumModalContents, { ...otherProps, onClose: closeDialog }) })] }));
}
exports.default = ChangeSumModal;
